import React, { useContext } from 'react';
import { NotifierContext, INotifierContext } from '../context/NotifierContext';

export default function useNotifier() {
  const context = useContext<INotifierContext>(NotifierContext);

  if (context == null) {
    throw new Error("Context can only be used inside it's provider");
  }

  return context;
}
